import { checkCountersDisable } from '../analytics';
import { addAdriverEvent } from './adriver';
import { sendAstraLabEvent } from './astraLab';
import { PixelEventName, PixelEventsMap } from './events';
import { sendMarcomConversation } from './marcom';
import { sendRoxotEvent } from './roxot';
import { sendSolowayConversion } from './soloway';
import { sendWcmConversion } from './weborama';

const addEventPixels = (eventName: PixelEventName): void => {
    if (checkCountersDisable() || !Object.keys(PixelEventsMap).includes(eventName)) {
        return;
    }

    const handlers = PixelEventsMap[eventName];

    if (handlers.soloway) {
        sendSolowayConversion(handlers.soloway);
    }
    if (handlers.weborama) {
        handlers.weborama.forEach((tag) => sendWcmConversion(tag));
    }
    if (handlers.astraLab) {
        sendAstraLabEvent(handlers.astraLab);
    }
    if (handlers.adriver) {
        addAdriverEvent(handlers.adriver);
    }
    if (handlers.roxot) {
        sendRoxotEvent(handlers.roxot);
    }
    // old_wcm_start
    if (handlers.marcom) {
        sendMarcomConversation();
    }
    // old_wcm_end
};

export default addEventPixels;
